import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XDatePipe } from './pipes/x-date.pipe';
import { ScoreViewPipe } from './pipes/score-view.pipe';
import { GotoUrlPipe } from './pipes/goto-url.pipe';
import { PrematchAnimateValueDirective } from './directives/prematch-animate-value.directive';
import { SortDatePipe } from '@app/core/pipes/sort-date.pipe';
import { SwipeCloseDirective } from '@app/core/directives/swipe-close.directive';

@NgModule({
    imports: [
        CommonModule,
        PrematchAnimateValueDirective
    ],
    exports: [
        XDatePipe,
        ScoreViewPipe,
        GotoUrlPipe,
        SortDatePipe,
        PrematchAnimateValueDirective,
        SwipeCloseDirective,
    ],
    declarations: [
        XDatePipe,
        ScoreViewPipe,
        GotoUrlPipe,
        SortDatePipe,
        SwipeCloseDirective,
    ],
    providers: []
})
export class CoreModule { }
